import React from 'react';
import { View, StyleSheet } from 'react-native';
import PasswordForm from '../me/PasswordForm';

const PasswordModal = ({ navigation }) => {
  return (
    <View style={styles.body}>
      <PasswordForm
        onSubmit={() => {
          navigation.goBack();
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  body: {
    flex: 1,
    backgroundColor: 'white',
  },
});

export default PasswordModal;
